<div class="modal-header">
  <h4 class="modal-title pull-left">Virtue File Reader</h4>

  <u class="registered"><i class="fa fa-registered" aria-hidden="true"></i></u>

  <!-- <div *ngIf="errorMessage" class="error-msg">
    {{ errorMessage }}
    <br />
  </div> -->

  <button
    type="button"
    class="close pull-right"
    aria-label="close"
    (click)="close()"
    [ngClass]="IsLoadData == true ? 'disabled' : ''"
  >
    <!-- <svg  class="close pull-right" style="width: 22px;"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg> -->

    <span aria-hidden="true">×</span>
  </button>
</div>
<div class="modal-body">
  <div class="row mt-2">
    <div class="col-md-6">
      <div
        class="row mt-2"
        *ngFor="let element of fileUploadArray; let i = index"
      >
        <div class="col-xl-6 col-md-6 mb-2">
          <div class="form-group">
            <label for="formGroupExampleInput">Date of Submission</label>
            <input
              type="date"
              class="form-control"
              [(ngModel)]="element.dateOfAward"
              [max]="today"
              id="formGroupExampleInput"
              value="02/23/2021"
              placeholder="MM/DD/YYY"
            />
          </div>
        </div>
        <div class="col-xl-6 col-md-6 mb-2">
          <div class="form-group">
            <label for="formGroupExampleInput">University Name </label>
            <div>
              <input
                disabled
                class="form-control"
                type="text"
                [value]="universityData.name"
                name="universityData.name"
                [(ngModel)]="universityData.name"
              />
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-md-6 mb-2">
          <div class="form-group">
            <label for="formGroupExampleInput">Enrollment Year</label>
            <select
              class="form-control"
              [(ngModel)]="element.enrollmentYear"
              id="exampleFormControlSelect1"
            >
              <option *ngFor="let year of yearsArr">{{ year }}</option>
            </select>
          </div>
        </div>
        <div class="col-xl-6 col-md-6 mb-2"></div>
      </div>
      <tui-loader
        [inheritColor]="true"
        [showLoader]="IsLoadData"
        [overlay]="true"
        class="filter-row"
        id="hideloader"
      >
        <!-- *ngIf="response && fileUploadArray.detectedValues.length > 0" -->
        <div class="row mt-3 coa-col" *ngIf="viewImgPdfArray.length > 0">
          <div class="col-xl-12 col-md-12 mb-2 head-grant">
            <h4>Scholarship Grant</h4>
          </div>
          <div class="col-xl-6 col-md-6 mb-3 cols-f">
            <label>Total Cost of Attendance</label>
            <div>
              <div *ngIf="totalAmount.coaCorrect" class="value-col">
                {{
                  totalAmount.totalCoa | currency : "$ " : "symbol" : "1.0-0"
                }}
              </div>
              <div class="form-control efc-cl" *ngIf="!totalAmount.coaCorrect">
                <span class="prefix-cur">$</span>
                <tui-input-number
                  class="currency-input"
                  [prefix]="''"
                  [tuiTextfieldLabelOutside]="'true'"
                  [pseudoHovered]="'true'"
                  [max]="999999999999999"
                  [pseudoFocused]="'true'"
                  [(ngModel)]="totalAmount.totalCoa"
                  (ngModelChange)="changeAnalysisTotal()"
                >
                </tui-input-number>
              </div>

              <div class="ops">
                <span
                  class="tick ml-2"
                  *ngIf="totalAmount.coaCorrect"
                  (click)="totalAmount.coaValidated = !totalAmount.coaValidated"
                  ><i class="fa fa-check"></i
                ></span>
                <span
                  class="closem ml-2"
                  (click)="totalAmount.coaCorrect = false"
                  ><i class="fa fa-edit"></i
                ></span>
              </div>
            </div>
            <div class="subline">(Includes Direct and Indirect Costs)</div>
          </div>
          <div class="col-xl-6 col-md-6 mb-3 cols-f">
            <label>Total Grants & Scholarships</label>
            <div class="">
              <div *ngIf="totalAmount.grantCorrect" class="value-col">
                {{
                  totalAmount.totalGrantsSCholarship
                    | currency : "$ " : "symbol" : "1.0-0"
                }}
              </div>
              <div
                class="form-control efc-cl"
                *ngIf="!totalAmount.grantCorrect"
              >
                <span class="prefix-cur">$</span>
                <tui-input-number
                  class="currency-input"
                  [prefix]="''"
                  [tuiTextfieldLabelOutside]="'true'"
                  [pseudoHovered]="'true'"
                  [max]="999999999999999"
                  [pseudoFocused]="'true'"
                  [(ngModel)]="totalAmount.totalGrantsSCholarship"
                  (ngModelChange)="changeAnalysisTotal()"
                >
                </tui-input-number>
              </div>

              <div class="ops">
                <span
                  class="tick ml-2 grey-fill"
                  *ngIf="totalAmount.grantCorrect"
                  (click)="
                    totalAmount.grantValidated = !totalAmount.grantValidated
                  "
                  [ngClass]="{ 'green-fill': totalAmount.grantValidated }"
                >
                  <i class="fa fa-check"></i>
                </span>
                <span
                  class="closem ml-2"
                  (click)="totalAmount.grantCorrect = false"
                >
                  <i class="fa fa-edit"></i>
                </span>
              </div>
            </div>
            <div class="subline">
              (Excludes Federal Loan/Private Loan and Workstudy)
            </div>
          </div>
        </div>
      </tui-loader>
    </div>

    <div class="col-md-6">
      <div class="border rounded p-2 h-100 bg-light b-light">
        <div class="modal-header pt-1">
          <h4 class="modal-title pull-left ad-let">Award Letter</h4>

          <!-- <p *ngIf="errorMessage" class="error-msg">{{errorMessage}} ({{uploadFileType[0]}})</p> -->
          <span class="al-close">
            <!-- *ngIf="
            fileUploadArray[0].fileIds &&
            fileUploadArray[0].fileIds.length > 0
          " -->
            <img
              [ngClass]="IsLoadData == true ? 'disabled' : ''"
              title="Remove Award Letter"
              *ngIf="viewImgPdfArray.length > 0"
              (click)="resetFile()"
              src="https://cdn.virtueanalytics.com/cache/college-del-icon.png"
            />
          </span>
        </div>

        <tui-loader
          [inheritColor]="true"
          [showLoader]="IsLoadData"
          [overlay]="true"
          class="filter-row"
        >
          <!-- ngClass="{{ dragAreaClass }}" -->
          <!-- *ngFor="let element of fileUploadArray; let i = index" -->
          <!-- *ngIf="!element.fileIds || element.fileIds.length == 0" -->
          <div draggable="true" ngClass="{{ dragAreaClass }}">
            <div
              class="bg-light row align-items-center justify-content-center mx-2 mt-2 default-aw relative"
              *ngIf="viewImgPdfArray.length == 0"
            >
              <img
                src="https://cdn.virtueanalytics.com/cache/upload-files-filedrak.png"
                class="upload-img"
                width="130"
              />
              <div class="form-group upload-sec text-center">
                <a href="javascript:void(0)" (click)="file.click()">
                  <span class="upload-btn">
                    <input
                      type="file"
                      #file
                      [multiple]="false"
                      (change)="onFileChange($event)"
                      style="display: none"
                    />

                    Drop Award letter here or Click to browse
                  </span>
                </a>
                <p>(PDF, JPG, JPEG and PNG files are supported)</p>
                <br />
                <p *ngIf="errorMessage" class="error-msg">{{ errorMessage }}</p>
              </div>
            </div>
            <!-- Static Upload File -->
            <!-- *ngIf="element.fileIds && element.fileIds.length > 0" -->
            <ng-container *ngIf="viewImgPdfArray.length > 0">
              <div (click)="reset()" class="reset-in-row">
                <svg
                  class="h-6 w-6"
                  title="Reset"
                  viewBox="0 0 21 21"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#f26722"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <g
                      fill="none"
                      fill-rule="evenodd"
                      stroke="#f26722"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      transform="translate(3 1)"
                    >
                      <path
                        d="m.5 7.5c0 2.7614237 2.23857625 5 5 5 2.76142375 0 5-2.2385763 5-5 0-2.76142375-2.23857625-5-5-5-1.60217594 0-3.02834512.75357449-3.94340319 1.92561913"
                      ></path>
                      <path d="m1.5.5v4h4"></path>
                      <path d="m14.5 16.5-5.379-5.379"></path>
                    </g>
                  </g>
                </svg>
                <!-- <img
                  src="https://cdn.virtueanalytics.com/no-cache/reset-fm.png"
                  title="reset"
                  class="cursor-pointer"
                /> -->
              </div>
              <div class="zoomoptions mr-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  [ngClass]="isZoomInDisable == true ? 'svg-disabled' : ''"
                  (click)="zoomin()"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM10.5 7.5v6m3-3h-6"
                  />
                </svg>
                <svg
                  [ngClass]="isZoomOutDisable == true ? 'svg-disabled' : ''"
                  (click)="zoomout()"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM13.5 10.5h-6"
                  />
                </svg>
              </div>

              <div
                class="modal-body award-body mt-4"
                *ngIf="viewImgPdfArray.length > 0"
              >
                <!-- [ngClass]="isimage == true ? 'addoverflow' : ''" -->
                <!-- [src]="element.URL"
                [show-all]="true"
                [render-text]="false"
                class="viewer" -->
                <div
                  class="awd-let-frm relative"
                  *ngIf="isimage && viewImgPdfArray"
                >
                  <ng-container *ngIf="viewImgPdfArray.length > 0">
                    <ng-container
                      *ngFor="let element of viewImgPdfArray; let i = index"
                    >
                      <img
                        class="award-letter zoom-in-out"
                        [src]="element.URL"
                        [style.width.%]="zoomValue"
                        [style.height.%]="zoomValue"
                        alt=""
                      />
                    </ng-container>
                  </ng-container>
                </div>

                <div
                  class="relative"
                  style="height: 450px"
                  *ngIf="ispdf && viewImgPdfArray"
                >
                  <ng-container *ngIf="viewImgPdfArray.length > 0">
                    <ng-container
                      *ngFor="let element of viewImgPdfArray; let i = index"
                    >
                      <pdf-viewer
                        [src]="element.URL"
                        [zoom]="zoom"
                        [render-text]="true"
                        [original-size]="false"
                        class="award-letter"
                        style="width: 100%; height: 450px"
                      ></pdf-viewer>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </tui-loader>
      </div>
    </div>
    <div class="col-12 text-center mt-4 border-t pt-3">
      <button
        class="btn btn-primary page-btn"
        (click)="changeAnalysis()"
        [disabled]="totalAmount.grantCorrect && totalAmount.coaCorrect"
      >
        Update
      </button>
      <button
        class="btn btn-primary page-btn"
        aria-label="Close"
        (click)="close()"
        [disabled]="IsLoadData == true"
      >
        Close
      </button>
    </div>
  </div>
</div>
